import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {BrowserRouter as Router} from "react-router-dom";
import {Provider} from 'react-redux'
import {createStore } from 'redux'
import rootReducer from './Reducers'
import {persistStore, persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {PersistGate} from 'redux-persist/integration/react';
// import 'react-owl-carousel2/style.css';
import Routes from "./Routes";
import { devToolsEnhancer} from 'redux-devtools-extension';
import TimeAgo from 'javascript-time-ago'

import en from 'javascript-time-ago/locale/en'
import ru from 'javascript-time-ago/locale/ru'


import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import ReactPWAInstallProvider from "react-pwa-install";

TimeAgo.addDefaultLocale(en)
TimeAgo.addLocale(ru)

const persistConfig = {
    key: 'root',
    blacklist: ['imageReducer'],
    storage,
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer,devToolsEnhancer());

const persistor = persistStore(store);

const routing = (
	// <ReactPWAInstallProvider enableLogging>
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Router >
                <Routes />
            </Router>
        </PersistGate>
    </Provider>
	// </ReactPWAInstallProvider>

);

ReactDOM.render(routing,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register();
